// extracted by mini-css-extract-plugin
export var buttonContainer = "_77-1";
export var fontSizeSelect = "_77-3";
export var formatSelect = "_77-2";
export var formats = "_77-4";
export var hidden = "_77-5";
export var icon = "_77-6";
export var select = "_77-0";